{
  "title": "Dashboard",
  "greeting": {
    "morning": "Good morning",
    "evening": "Good evening"
  },
  "subtitle": "{{month}} · {{greeting}}, {{name}}",
  "newBooking": "New booking",
  "stats": {
    "monthBookings": {
      "label": "Bookings this month",
      "sub": "Confirmed since the start of the month"
    },
    "netFees": {
      "label": "Net agency fees",
      "sub": "From {{fees}} in fees after coordinator shares"
    },
    "awaiting": {
      "label": "Invoices awaiting payment",
      "oldest": "oldest {{n}} days ago"
    },
    "coordinatorDues": {
      "label": "Commissions due to coordinators",
      "sub": "For {{n}} coordinators · not transferred yet"
    },
    "monthExpenses": {
      "label": "Expenses this month",
      "sub": "{{n}} expenses since the start of the month"
    },
    "netProfit": {
      "label": "Net profit",
      "sub": "Net fees {{fees}} − expenses {{expenses}}"
    }
  },
  "recent": {
    "title": "Latest bookings",
    "viewAll": "View all",
    "empty": "No bookings yet",
    "columns": {
      "reference": "Booking no.",
      "customerPartner": "Customer · Partner",
      "fee": "Fee",
      "coordinator": "Coordinator",
      "status": "Status"
    }
  },
  "unpaid": {
    "title": "Invoices awaiting payment",
    "all": "All",
    "empty": "No open invoices",
    "billing": {
      "full": "Full invoice",
      "feeOnly": "Fee only"
    },
    "failureBanner": "A payment attempt failed for invoice <num>{{number}}</num>{{reason}}. The invoice is still open."
  }
}
